import React, { useRef, useEffect, useState } from "react";
import { gsap } from "gsap";
import img1 from "../src/img1.png";
import img2 from "../src/img2.jpg";
import img3 from "../src/img3.png";
import img4 from "../src/img4.png";
import img5 from "../src/img5.png";
import img6 from "../src/img6.png";
import img7 from "../src/img7.png";
import award from "../src/svg/award-svgrepo-com 1.svg";
import bag from "../src/svg/bag-4-svgrepo-com 1.svg";
import cart from "../src/svg/cart-large-2-svgrepo-com 5.svg";
import headphone from "../src/svg/headphone-svgrepo-com 1.svg";
import person from "../src/svg/person 1.svg";
import right from "../src/svg/right arrow 1.svg";
import left from "../src/svg/left arrow 1.svg";
import heart from "../src/svg/heart-svgrepo-com (1) 1.svg";

import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);



// Data for best sellers (landing page carousel)
const bestSellers = [
  {
    img: img4,
    name: "ALYA SKIN CLEANSER.",
    price: "FROM $29.99",
  },
  {
    img: img5,
    name: "RITUAL OF SAKURA.",
    price: "FROM $27.99",
  },
  {
    img: img6,
    name: "THE BODY LOTION.",
    price: "FROM $19.99",
  },
];

// Data for FAQ and product grid (next page)
const faqs = [
  {
    q: "Are your products safe for sensitive skin?",
    a: "",
  },
  {
    q: "Are your products cruelty-free?",
    a: "Absolutely! All our products are cruelty-free, and most are vegan. Check individual product details for specifics.",
  },
  {
    q: "What’s your return policy?",
    a: "",
  },
  {
    q: "Do you ship internationally?",
    a: "",
  },
  {
    q: "How do i choose the right product?",
    a: "",
  },
];
const text =
  "Experience the ultimate in skincare with our expertly formulated products, crafted to nourish, protect, and rejuvenate your skin. Combining the finest natural ingredients with advanced science, our collection ensures every skin type can achieve a radiant, healthy glow. Embrace your beauty with confidence every day. Experience the ultimate in skincare with our expertly formulated products, crafted to nourish, protect, and rejuvenate your skin.";


const products = [
  {
    img: img4,
    name: "ALYA SKIN CLEANSER.",
    price: "FROM $29.99",
  },
  {
    img: img5,
    name: "RITUAL OF SAKURA.",
    price: "FROM $27.99",
  },
  {
    img: img6,
    name: "THE BODY LOTION.",
    price: "FROM $19.99",
  },
];

const categories = [
  { label: "NEW ARRIVAL", active: true },
  { label: "CLEANSING" },
  { label: "ACNE FIGHTER" },
  { label: "ANTI AGING" },
];

export default function SkincareCombined() {
  // Landing page animated paragraph
  const paraRef = useRef(null);

useEffect(() => {
  if (paraRef.current) {
    const words = paraRef.current.querySelectorAll(".anim-word");

    gsap.set(words, { color: "#bdbdbd" });

    gsap.to(words, {
      color: "#1A1A1A",
      stagger: 0.05,
      ease: "power2.out",
      scrollTrigger: {
        trigger: paraRef.current,
        start: "top 80%",
        toggleActions: "play none none reverse",
      },
    });
  }
}, []);

  // Landing page carousel
  const [current, setCurrent] = useState(0);
  const handlePrev = () => setCurrent((prev) => (prev === 0 ? bestSellers.length - 1 : prev - 1));
  const handleNext = () => setCurrent((prev) => (prev === bestSellers.length - 1 ? 0 : prev + 1));

  // FAQ open state (for next page)
  const [openFaq, setOpenFaq] = useState(1);

  return (
    <div className="bg-[#f7faed] min-h-screen w-full font-Inter text-[#222]">
      {/* NAVBAR */}
      <nav className="flex items-center justify-between px-8 py-6">
        <div className="font-extrabold text-2xl tracking-tight">SKINCARE</div>
        <div className="hidden md:flex gap-8 text-[17px]">
          <a href="#">All Products</a>
          <a href="#">Serum</a>
          <a href="#">Sunscreen</a>
          <a href="#">Bundle</a>
        </div>
        <div className="flex items-center gap-5">
          <img src={cart} alt="cart" className="w-6 h-6" />
          <span className="text-sm">Cart(1)</span>
          <img src={person} alt="person" className="w-6 h-6" />
          <img src={heart} alt="like" className="w-6 h-6" />
        </div>
      </nav>


      {/* Big SKINCARE background text */}
      <div className="pointer-events-none select-none absolute left-0 right-0 bottom-[100px] w-full flex justify-center z-0">
 <h1 className="absolute inset-0 flex items-center justify-center text-[18vw] font-extrabold opacity-[1] w-full text-background: #2D3B36;
 pointer-events-none select-none leading-none whitespace-nowrap">
  SKINCARE
</h1>

      </div>

      {/* Main content */}
      <section className="relative z-10 max-w-7xl mx-auto w-full flex flex-col items-center">
        {/* Top Row */}
        <div className="w-full flex flex-row items-start justify-between mt-4 md:mt-12">
          {/* Left: Text and button */}
          <div className="flex flex-col flex-1 items-start">
            <p className="max-w-[250px] text-[15px] text-[#232826] leading-snug mt-2 ml-2 text-left">
              Transform your skincare routine with premium products that restore, protect, and enhance your natural glow every day.
            </p>
            <button className="mt-8 ml-2 px-6 py-2 bg-[#232826] text-white rounded-full text-base hover:bg-[#454b48] transition font-medium">
              Shop Now
            </button>
          </div>
          {/* Center: Headline */}
        <div className="flex flex-col items-center flex-1">
  {/* Desktop Text */}
  <h1 className="hidden md:block text-[40px] md:text-[54px] font-extrabold leading-[1.05] text-center tracking-tight text-[#232826] select-none mt-0">
    <span className="block">GLOW</span>
    <span className="block">NATUR-</span>
    <span className="block">ALLY</span>
  </h1>

  {/* Mobile Text */}
  <h1 className="block md:hidden text-[32px] font-extrabold leading-tight text-center tracking-tight text-[#232826] select-none mt-0">
    <span className="block">Growww</span>
    <span className="block mt-1">Naturally</span>
  </h1>
</div>

          {/* Right: Product image */}
          <div className="flex flex-col items-end flex-1">
            <div className="w-[110px] h-[110px]  rounded flex items-center justify-center  ">
              <img
                src={img2}
                alt="Product"
                className="object-contain w-[190px] h-[190px] rounded"
              />
            </div>
          </div>
        </div>

        {/* Centered Hero Image */}
<div className="relative flex flex-col items-center">
  <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
    <img
      src={img1}
      alt="Hero"
      className="w-[330px] h-[330px] md:w-[380px] md:h-[380px] object-cover"
    />
    {/* Experience badge */}
    <div className="absolute left-1/2 -translate-x-1/2 bottom-4 flex items-center bg-white/90 rounded-full px-4 py-2 shadow-md border border-gray-200 text-sm font-medium gap-2 w-[90%]">
      <img src={img2} alt="icon" className="w-8 h-8" />
      <span className="line-clamp-2 leading-snug text-center">
        While giving you an invigorating<br />cleansing experience.
      </span>
    </div>
  </div>
</div>


</section>



      {/* ANIMATED PARAGRAPH */}
     <section className="relative z-10  py-16  px-3 mx-auto">
  <p
    ref={paraRef}
    className="text-[20px] md:text-[24px] font-normal leading-relaxed flex flex-wrap gap-x-[6px]"
  >
    {text.split(" ").map((word, idx) => (
      <span key={idx} className="anim-word text-[#bdbdbd] transition-colors duration-500">
        {word}
      </span>
    ))}
  </p>
</section>

      

      {/* WHY OUR PRODUCTS */}
      <section className="flex flex-col md:flex-row items-center justify-between px-8 py-16 gap-8 bg-[#f7faed]">
        <div className="flex-1">
          <button className="mb-4 px-5 py-2 border border-[#232826] rounded-full bg-white text-[#232826] font-medium">
            ● Why Our Products
          </button>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            YOUR SKIN DESERVES THE BEST CARE.
          </h2>
          <p className="mb-8 text-gray-700 max-w-md">
            Discover a curated collection of skincare products designed to rejuvenate, protect, and pamper your skin. Explore our rage crafted with love backed by science, and inspired by nature.
          </p>
  <div className="space-y-7">
  {[
    {
      num: "01",
      title: "Bio Ingredients",
      desc: "Get naturally beautiful and transform with our bio ingredients creams for healthy, radiant skin.",
    },
    {
      num: "02",
      title: "Everything Natural",
      desc: "Pure ingredients for pure skin. The Perfect solution for your skin care needs.",
    },
    {
      num: "03",
      title: "All Handmade",
      desc: "Made with love and care. Just for you. Give your skin the tender loving care it deserves.",
    },
  ].map((item, idx) => (
    <div key={idx}>
      <span className="text-4xl md:text-5xl font-bold mr-3 bg-gradient-to-b from-[#293330] to-[#FEFFF4] bg-clip-text text-transparent leading-tight block">
        {item.num}
      </span>
      <span className="text-xl font-semibold">{item.title}</span>
      <div className="text-gray-700 text-[15px] mt-1">{item.desc}</div>
    </div>
  ))}
</div>

        </div>
        {/* Right image with badge and footer */}
     <div className="flex-1 flex flex-col items-center justify-end min-h-[480px]">
  <div className="relative w-full flex justify-center">
    <img
      src={img3}
      alt="bio"
      className="w-full md:w-[340px] lg:w-[400px] aspect-[4/5] object-cover rounded-2xl border-4  shadow"
      style={{ maxWidth: "420px" }}
    />
    {/* Award badge */}
    <div className="absolute left-1/2 -translate-x-1/2 bottom-[28px] flex items-center bg-[#f7faed] border border-gray-200 rounded-full px-5 py-2 shadow-md">
      <img src={award} alt="award" className="w-7 h-7 mr-2" />
      <span className="text-sm font-medium">
        Best Skincare Product Award Winning
      </span>
      
  
    </div>
    
    
  </div>
  {/* Footer bar: SINCE 2001 left, LEARN MORE right */}
  <div className="  mt-1 px-9 justify-between items-centre flex text-gray-600 ">
    <span className="text-left">SINCE 2001</span>
    
    <span className="text-right">LEARN MORE</span>
  </div>
  
</div>

      </section>

<section className="px-4 py-16 bg-[#f7faed] overflow-hidden no-scrollbar">
  <div className="flex flex-row items-center mb-6 text-center justify-between">
  <button className="mb-4 px-5 py-2 border border-[#232826] rounded-full bg-white text-[#232826] font-medium">
    ● Best Selling Products
  </button>

  {/* Heading + Arrows */}
    
    <h2 className="text-2xl md:text-3xl font-bold max-w-2xl">
      Skincare That Brings Out Your Natural Radiance
    </h2>
    <div className="flex gap-4">
      <button
        onClick={handlePrev}
        className="w-10 h-10 rounded-full bg-[#232826] flex items-center justify-center"
      >
        <img src={left} alt="left" className="w-5 h-5 invert" />
      </button>
      <button
        onClick={handleNext}
        className="w-10 h-10 rounded-full bg-[#232826] flex items-center justify-center"
      >
        <img src={right} alt="right" className="w-5 h-5 invert" />
      </button>
    </div>
  </div>

  {/* Scrollable product row */}
<div className="flex gap-6 overflow-x-auto no-scrollbar justify-center px-2">
  {bestSellers.map((prod, idx) => (
  <div
        key={prod.name}
        className="relative rounded-2xl overflow-hidden shadow-md max-w-xs w-full mx-auto"
      >
        {/* Product Image */}
        <img
          src={prod.img}
          alt={prod.name}
          className="w-full h-[340px] object-cover"
        />

        {/* White Overlay Card */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-[90%] bg-white/95 rounded-xl shadow-md px-5 py-4 flex items-center justify-between">
          {/* Left: Name & Price */}
          <div className="text-left">
            <h3 className="text-[#232826] font-semibold text-sm md:text-base leading-tight">
              {prod.name}
            </h3>
            <p className="text-gray-600 text-xs mt-1">{prod.price}</p>
          </div>

          {/* Right: Bag Icon Button */}
          <button className="bg-white border border-gray-300 rounded-lg p-2 hover:bg-gray-100 transition">
            <img src={bag} alt="bag" className="w-5 h-5" />
          </button>
        </div>
      </div>
  ))}
</div>


</section>


      {/* --- NEXT PAGE: HERO SECTION --- */}
      <section className="flex flex-col items-center justify-center   px-5 py-12 rounded-3xl relative">
        <img
          src={img7}
          alt="Skincare product"
          className="w-full h-[800px]  "
          style={{ objectPosition: "center" }}
        />
        <div className="absolute inset-0 flex flex-col justify-end items-center pb-12 bg-gradient-to-t from-black/50 via-transparent to-transparent rounded-3xl">
          <h1 className="text-white text-3xl md:text-4xl font-medium text-center mb-6 ">
            Feel Beautiful Inside and Out<br />with Every Product.
          </h1>
          <button className="bg-white text-[#222] px-6 py-2 rounded-full text-base font-medium  transition">
            Shop Now
          </button>
        </div>
      </section>
      {/* --- NEXT PAGE: PRODUCT GRID --- */}
     <section className="py-16 px-4 bg-[#f7faed]">
  <h2 className="text-4xl md:text-5xl font-semibold text-center mb-12 leading-tight">
    Feel Beautiful Inside and Out<br />with Every Product.
  </h2>

  {/* Category Buttons */}
  <div className="flex flex-wrap justify-center gap-3 mb-12">
    {categories.map((cat, idx) => (
      <button
        key={cat.label}
        className={`px-5 py-2 rounded-full border transition font-medium ${
          cat.active
            ? "bg-[#232826] text-white border-[#232826]"
            : "bg-white text-[#232826] border-[#232826]/20"
        }`}
      >
        {cat.label}
      </button>
    ))}
  </div>

  {/* Product Grid */}
  <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-6xl mx-auto">
    {products.map((prod) => (
      <div
        key={prod.name}
        className="relative rounded-2xl overflow-hidden shadow-md max-w-xs w-full mx-auto"
      >
        {/* Product Image */}
        <img
          src={prod.img}
          alt={prod.name}
          className="w-full h-[340px] object-cover"
        />

        {/* White Overlay Card */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-[90%] bg-white/95 rounded-xl shadow-md px-5 py-4 flex items-center justify-between">
          {/* Left: Name & Price */}
          <div className="text-left">
            <h3 className="text-[#232826] font-semibold text-sm md:text-base leading-tight">
              {prod.name}
            </h3>
            <p className="text-gray-600 text-xs mt-1">{prod.price}</p>
          </div>

          {/* Right: Bag Icon Button */}
          <button className="bg-white border border-gray-300 rounded-lg p-2 hover:bg-gray-100 transition">
            <img src={bag} alt="bag" className="w-5 h-5" />
          </button>
        </div>
      </div>
    ))}
  </div>
</section>


      {/* --- NEXT PAGE: FAQ SECTION --- */}
      <section className="py-16 px-4 bg-[#f7faed] grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto items-start">
        {/* FAQ Image & Help */}
        <div className="flex-1 flex flex-col items-center justify-end min-h-[480px]">
  <div className="relative w-full flex justify-center">
    {/* Image */}
    <img
      src={img6}
      alt="FAQ"
      className="w-full h-full lg:w-[400px] aspect-[4/5] object-cover rounded-2xl"
      style={{ maxWidth: "420px" }}
    />

    {/* Badge Overlaid Inside Image */}
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white/90 border border-gray-200 rounded-full px-5 py-2 shadow-md flex items-center">
      <img src={headphone} alt="support" className="w-6 h-6 mr-2" />
      <span className="text-sm font-medium text-[#232826]">
        24/7 We're Here to Help You
      </span>
    </div>
  </div>
</div>

        {/* FAQ Content */}
        <div>
          <button className="mb-4 px-5 py-2 border border-[#232826] rounded-full bg-white text-[#232826] font-medium">
            ● Frequently Asked Question
          </button>
          <h2 className="text-3xl md:text-4xl font-medium mb-8">
            Answers to Your<br />Skincare Questions, All<br />in One Place.
          </h2>
          <div className="space-y-2">
            {faqs.map((faq, idx) => (
              <div key={faq.q} className="border border-[#dfe3d9] rounded-lg bg-white">
                <button
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  className="w-full flex items-center justify-between px-4 py-4 text-lg font-medium text-left focus:outline-none"
                >
                  {faq.q}
                  <span className="ml-4 text-2xl select-none">
                    {openFaq === idx ? "−" : "+"}
                  </span>
                </button>
                <div
                  className={`px-4 pb-3 text-[#444] text-base transition-all duration-300 ease-in-out ${
                    openFaq === idx ? "max-h-40 opacity-100" : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  {faq.a}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
{/* Contact & Links Footer */}
<footer className="relative bg-[#22332F] text-white min-h-[320px] px-6 overflow-hidden flex flex-col justify-between">
  {/* Main content at the top */}
  <div className="flex flex-col md:flex-row justify-between items-start md:items-center max-w-7xl mx-auto pt-12 w-full z-10">
    {/* Left Section */}
    <div>
      <h2 className="text-2xl md:text-3xl font-semibold mb-2">
        Join The Skincare<br />Community Now.
      </h2>
      <div className="flex flex-wrap justify-between text-gray-200 mb-2">
        <a href="#">Facebook</a>
        <a href="#">Instagram</a>
        <a href="#">YouTube</a>
      </div>
    </div>

    {/* Right Section - Get in Touch */}
    <div className="mt-10 md:mt-0 text-left md:text-right w-full md:w-auto">
      <p className="text-lg mb-1">Get in Touch</p>
      <a href="mailto:contact.skincare.com" className="text-2xl md:text-3xl font-medium block">
        contact.skincare.com
      </a>
      <div className="flex flex-wrap justify-start md:justify-center gap-x-6 text-sm text-gray-200 mt-4">
        <a href="#">Terms of Service</a>
        <a href="#">Reporting Guide</a>
        <a href="#">Customer Policy</a>
      </div>
    </div>
  </div>
</footer>

{/* Separate Background Footer */}
{/* Background SKINCARE Footer */}
<footer className="relative bg-[#22332F] px-6 pt-24 pb-24 overflow-visible">
  <div className="pointer-events-none select-none relative w-full flex justify-center z-0">
    <h1 className="text-[clamp(80px,18vw,250px)] font-extrabold text-[#35433E] leading-none whitespace-nowrap">
      SKINCARE
    </h1>
  </div>
</footer>



    </div>
  );
}
